import moment from "moment";

/// Chat-style timestamp:
///   Just now · 5 min ago · 3 hours ago (today) · Yesterday, 14:20 ·
///   Mon, 14:20 (last 7 days) · 12 Mar, 14:20 (this year) · 12 Mar 2024
export const formatRelativeTime = (date, now = moment()) => {
  if (!date) return "-";
  const m = moment(date);
  if (!m.isValid()) return "-";

  const minutes = now.diff(m, "minutes");
  if (minutes < 1) return "Just now";
  if (minutes < 60) return `${minutes} min ago`;
  if (m.isSame(now, "day")) {
    const hours = now.diff(m, "hours");
    return `${hours} hour${hours === 1 ? "" : "s"} ago`;
  }
  if (m.isSame(now.clone().subtract(1, "day"), "day")) {
    return `Yesterday, ${m.format("HH:mm")}`;
  }
  if (now.diff(m, "days") < 7) return m.format("ddd, HH:mm");
  if (m.isSame(now, "year")) return m.format("DD MMM, HH:mm");
  return m.format("DD MMM YYYY");
};

/// Full timestamp, used as the tooltip of a relative time.
export const formatFullTime = (date) =>
  date && moment(date).isValid()
    ? moment(date).format("dddd, DD MMM YYYY · HH:mm:ss")
    : "";
